<script setup>
const currentYear = new Date().getFullYear()

const solutions = [
  { to: '/soluciones', label: 'Aeris' },
  { to: '/soluciones', label: 'Brixmog' },
  { to: '/soluciones', label: 'Brixion' },
  { to: '/soluciones', label: 'Climate Intelligence' },
]

const company = [
  { to: '/empresa',    label: 'Empresa' },
  { to: '/industrias', label: 'Industrias' },
  { to: '/tecnologia', label: 'Tecnología' },
  { to: '/contacto',   label: 'Contacto' },
]
</script>

<template>
  <footer class="footer">
    <div class="container footer__inner">

      <!-- Marca -->
      <div class="footer__brand">
        <RouterLink to="/" class="footer__logo-link" aria-label="Brixel Technologies">
          <img src="@/assets/logo/Brixel_logo_H2.svg" alt="Brixel Technologies" class="footer__logo-img" />
        </RouterLink>
        <p class="footer__tagline">Inteligencia para el mundo físico.</p>
        <p class="footer__location">México · Colombia</p>
      </div>

      <!-- Soluciones -->
      <div class="footer__col">
        <p class="footer__col-title">Soluciones</p>
        <nav>
          <RouterLink v-for="link in solutions" :key="link.label" :to="link.to" class="footer__link">
            {{ link.label }}
          </RouterLink>
        </nav>
      </div>

      <!-- Empresa -->
      <div class="footer__col">
        <p class="footer__col-title">Empresa</p>
        <nav>
          <RouterLink v-for="link in company" :key="link.to" :to="link.to" class="footer__link">
            {{ link.label }}
          </RouterLink>
        </nav>
      </div>

      <!-- Contacto -->
      <div class="footer__col">
        <p class="footer__col-title">Contacto</p>
        <a href="mailto:contacto@brixeltechnologies.com" class="footer__link">contacto@brixeltechnologies.com</a>
        <RouterLink to="/contacto" class="footer__cta">Agendar diagnóstico →</RouterLink>
      </div>

    </div>

    <div class="footer__bottom">
      <div class="container footer__bottom-inner">
        <p>© {{ currentYear }} Brixel Technologies. Todos los derechos reservados.</p>
        <p>México · Colombia</p>
      </div>
    </div>
  </footer>
</template>

<style scoped lang="scss">
@import '@/styles/variables';

.footer {
  background: $color-bg-dark;
  color: $color-text-muted;

  &__inner {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1.5fr;
    gap: $space-12;
    padding-top: $space-16;
    padding-bottom: $space-12;

    @media (max-width: $bp-lg) {
      grid-template-columns: 1fr 1fr;
      gap: $space-8;
    }

    @media (max-width: $bp-sm) {
      grid-template-columns: 1fr;
      gap: $space-8;
    }
  }

  &__brand {
    display: flex;
    flex-direction: column;
    gap: $space-3;
  }

  &__logo-link {
    display: inline-block;
    text-decoration: none;
  }

  &__logo-img {
    height: 26px;
    width: auto;
    display: block;
    opacity: 0.9;
  }

  &__tagline {
    font-size: $text-sm;
    color: $color-text-muted;
    margin-top: $space-1;
  }

  &__location {
    font-size: $text-xs;
    color: rgba(156, 163, 175, 0.6);
    letter-spacing: 0.04em;
  }

  &__col {
    display: flex;
    flex-direction: column;
    gap: $space-3;

    nav {
      display: flex;
      flex-direction: column;
      gap: $space-2;
    }
  }

  &__col-title {
    font-size: $text-xs;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: rgba(255, 255, 255, 0.4);
    margin-bottom: $space-1;
  }

  &__link {
    font-size: $text-sm;
    color: $color-text-muted;
    text-decoration: none;
    transition: color $transition-fast;

    &:hover { color: #fff; }
  }

  &__cta {
    display: inline-block;
    margin-top: $space-3;
    font-size: $text-sm;
    font-weight: 600;
    color: $color-secondary;
    text-decoration: none;
    transition: color $transition-fast;

    &:hover { color: lighten(#517de8, 15%); }
  }

  &__bottom {
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    padding: $space-6 0;

    &-inner {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: $space-4;
      flex-wrap: wrap;

      p {
        font-size: $text-xs;
        color: rgba(156, 163, 175, 0.5);
      }
    }
  }
}
</style>
